<script>

import personService from "@/services/person.service"
import Dialog from 'primevue/dialog'
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate"
import { ref } from "vue"
import * as yup from 'yup'

export default {
    name: 'PersonPanel',
    components: {
        personService,
        Dialog,
        VeeForm,
        Field,
        ErrorMessage,
    },
    data() {
        return {
            showModal: ref(false),
            loading: false,
            uuid: null,
            person_group_uuid: null,
            name: '',
            email: '',
            phone: '',
            visible: ref(false),
        }
    },
    setup() {
        const schema = yup.object().shape({
            name: yup.string().required("Le nom est obligatoire"),
            email: yup.string().nullable().email("Le format de l'email n'est pa correct"),
        })

        return {
            schema,
        }
    },
    props: {
        externShowModal: {
            type: Boolean
        },
        externName: {
            type: Object
        },
        externPersonGroupUuid: {
            type: String
        }
    },
    watch: { 
        externShowModal: function(newVal) {
            this.showModal = newVal;
        },
        externName: function(newVal) {
            this.uuid = newVal?.uuid
            this.name = newVal?.name
            this.email = newVal?.email
            this.phone = newVal?.phone
            this.note = newVal?.note
        },
        externPersonGroupUuid: function(newVal) {
            this.person_group_uuid = newVal;
        },
    },
    methods: {
        beforeClose () {
            let person = {
                uuid: this.uuid,
                person_group_uuid: this.person_group_uuid,
                name: this.name,
                email: this.email,
                phone: this.phone,
                note: this.note,
            }

            this.showModal = false
            this.$emit('close', person)
        },
        handleAction() {
            if(this.uuid == null) {
                this.creerAction()
            } else {
                this.modifierAction()
            }
        },
        creerAction() {
            this.loading = false

            let person = {
                person_group_uuid: this.person_group_uuid,
                name: this.name,
                email: this.email,
                phone: this.phone,
                note: this.note,
            }
            this.$store.dispatch('account/addPerson', person)
            .then(() => {
                this.uuid = this.$store.state.account.lastPersonAdded.uuid
                this.name = this.$store.state.account.lastPersonAdded.name
                this.email = this.$store.state.account.lastPersonAdded.email
                this.phone = this.$store.state.account.lastPersonAdded.phone
                this.note = this.$store.state.account.lastPersonAdded.note

                this.showModal = false
                this.loading = false
            })
            .catch(err => {
                if(err.response.status == 401) {
                    this.$moshaToast("Vous n'êtes pas autorisé à créer des clients.", {
                        timeout: 3000,
                        hideProgressBar: true,
                        type: 'warning',
                        swipeClose: true,
                        position: 'top-center',
                    })
                } else {
                    this.$moshaToast(err.response.data.exception_message, {
                        timeout: 3000,
                        hideProgressBar: true,
                        type: 'warning',
                        swipeClose: true,
                        position: 'top-center',
                    })
                }
            })
        },
        modifierAction() {
            this.loading = false

            this.$store.dispatch('account/updatePerson', {
                person_group_uuid: this.person_group_uuid,
                uuid: this.uuid,
                name: this.name,
                email: this.email,
                phone: this.phone,
                note: this.note,
            })
            .then(() => {
                this.showModal = false
                this.loading = false
            })
            .catch(err => {
                if(err.response.status == 401) {
                    this.$moshaToast("Vous n'êtes pas autorisé à modifier les clients.", {
                        timeout: 3000,
                        hideProgressBar: true,
                        type: 'warning',
                        swipeClose: true,
                        position: 'top-center',
                    })
                } else {
                    this.$moshaToast(err.response.data.exception_message, {
                        timeout: 3000,
                        hideProgressBar: true,
                        type: 'warning',
                        swipeClose: true,
                        position: 'top-center',
                    })
                }
            })
        },
        close() {
            this.showModal = false
        }
    },
}

</script>

<template>
    <Dialog
        v-model:visible="showModal"
        modal
        class="flex justify-center items-center"
        :showHeader="false"
        :dismissableMask="true"
        :baseZIndex="1500"
        contentClass="relative p-0 rounded-lg bg-white dark:bg-gray-900"
        @hide="beforeClose"
    >
        <header class="bg-orange-300 p-2">
            <div class="text-right">
            <div @click="close()" class="cursor-pointer">Fermer</div>
            </div>
        </header>
        <div class="m-0 px-16 py-10 relative bg-white dark:bg-gray-900 border border-orange-300">
            <VeeForm @submit="handleAction" :validation-schema="schema" class="flex flex-col gap-4">
                <Field name="id" v-model="uuid" type="hidden" />

                <div class="form-group grid grid-cols-form-libre gap-4">
                    <span class="flex flex-col justify-center">Nom</span>
                    <Field name="name" v-model="name" class="form-control form-input" type="text" />
                </div>
                <ErrorMessage name="name" v-slot="{ message }">
                    <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                    {{ message }}
                    </div>
                </ErrorMessage>
                
                <div class="form-group grid grid-cols-form-libre gap-4">
                    <div class="flex flex-col justify-center">Email</div>
                    <Field name="email" v-model="email" class="form-control form-input" type="text" />
                </div>
                <ErrorMessage name="email" v-slot="{ message }">
                    <div class="border border-red-400 text-red-700 px-4 py-0 mt-2 rounded relative" role="alert">
                    {{ message }}
                    </div>
                </ErrorMessage>
                
                <div class="form-group grid grid-cols-form-libre gap-4">
                    <div class="flex flex-col justify-center">Tél.</div>
                    <Field name="phone" v-model="phone" class="form-control form-input" type="text" />
                </div>
                <div class="mt-4">
                    <label for="note">Note</label>
                    <Field v-slot="{ field, errors }" v-model="note" name="note" class="form-control w-full">
                        <textarea v-bind="field" name="note" class="w-full border border-orange-500 h-16" />
                        <div v-if="errors[0]">{{errors[0]}}</div>
                    </Field>
                    <ErrorMessage name="note" class="error-feedback" />
                </div>

                <div class="form-group flex justify-center gap-2 w-11/12 m-auto pt-2 pb-2 mt-10">
                    <button type="submit" class="btn" :disabled="loading">
                        <span class="spinner-border spinner-border-sm"></span>
                        <span v-show="uuid == null">Créer</span>
                        <span v-show="uuid != null">Modifier</span>
                    </button>
                </div>
            </VeeForm>
        </div>
    </Dialog>
</template>
